export enum ButtonGroupVariant {
  left = 'left',
  centered = 'centered',
  right = 'right',
  relativeCentered = 'centered relative'
}
